import {
  types,
  flow, getParent
} from 'mobx-state-tree';
// import {when} from 'mobx';

const URL = 'education-center/v1';

const MyLearning = types.model('MyLearning', {
  playlistId: types.optional(types.string, ''),
  currentPlaylistTitle: types.optional(types.string,''),
  totalVideos: types.optional(types.number, 0),
  videosWatched: types.optional(types.number, 0)
}).views(self => ({
  get transport5007() {
    return getParent(self,2).transport5007;
  },
  get watchedPercent() {
    if(self.totalVideos === 0){
      return 0;
    }
    return self.videosWatched/self.totalVideos*100;
  }
})).actions(self => ({
  fetchPlaylistTitle: flow(function* fetchPlaylistTitle(){
    if(!self.playlistId ) {
      return;
    }
    try {
      const {data} = yield self.transport5007.fetch(
        `${URL}/Playlists/${self.playlistId}`,
        {},
        {}
      )
      self.currentPlaylistTitle=data.title;
    } catch(e) {
      console.error('Failed fetching playlist title', e);
    }
  })
}));

export default MyLearning;
